import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useCallback, useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"
import { PropertyMarketSegmentApi, PropertySaveMarketsegment } from "../../Services/Service";
import swal from "sweetalert";
import { deletePropertyMarketSegment } from "../../Redux/Slices/Property/slice";

export const MarketSegmentList = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const deleting = useSelector((state) => state.propertyAgent.deleting);
    const [marketSegment, setMarketSegment] = useState([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([{ code: "", segment: "" }]);
    const [selectedRow, setSelectedRow] = useState({ ID: 0, Code: "", MarketSeg: "" });
    const [, setFormData] = useState({
        ID: 0,
        Code: "",
        MarketSeg: ""
    });


    useEffect(() => {
        if (location.state?.success) {
            setSuccessMessage(location.state.success);
            setShowSuccess(true);


            setTimeout(() => setShowSuccess(false), 4000);
        }
    }, [location.state]);

    const fetchMarketSegment = useCallback(async () => {
            setLoading(true);
            try {
                const result = await PropertyMarketSegmentApi();
                // setMarketSegment(result || []);
                if (Array.isArray(result)) setMarketSegment(result);
            }
            catch (error) {
                console.log("error fetching market segment", error);
            } finally {
                setLoading(false);
            }
    }, []);

    useEffect(() => {
        fetchMarketSegment();
    }, [fetchMarketSegment]);

    const handleDeleteClick = async (id) => {
        const shouldDelete = await swal({ title: "Are you sure?", icon: "warning", buttons: ["Cancel", "Delete"], dangerMode: true });
        if (!shouldDelete) return;
        try {
            const { response } = await dispatch(deletePropertyMarketSegment(id)).unwrap();
            await fetchMarketSegment();
            await swal(response?.Message || response?.message || "Market segment deleted successfully.", { icon: "success" });
        } catch (error) {
            await swal(error?.Message || error?.message || "Unable to delete market segment.", { icon: "error" });
        }
    };

    const handleAddRow = () => {
        setRows([...rows, { code: "", segment: "" }]);
    };

    const handleDeleteRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };

    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            for (let row of rows) {
                if (!row.code || !row.segment) {
                    swal("Please enter Code and select Market Segment !", {
                        icon: "warning",
                        buttons: {
                            confirm: {
                                text: "OK",
                                className: "btn btn-warning",
                            },
                        },
                    });
                    setLoading(false);
                    return;
                }
            }
            // Loop through all rows and submit each
            for (let row of rows) {
                const formdata = {
                    ID: 0, // or whatever ID you need
                    Code: row.code,
                    MarketSeg: row.segment
                };
                await PropertySaveMarketsegment(formdata);
            }

            swal("Market Segment Added Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Add-market-Segment")
                );
                if (modal) modal.hide();
            });

            // Reset rows
            setRows([{ code: "", segment: "" }]);
            setFormData({ ID: 0, Code: "", MarketSeg: "" });

            const result = await PropertyMarketSegmentApi();
            if (Array.isArray(result)) setMarketSegment(result);

        } catch (error) {
            console.log("Error adding market segment", error);
            alert("Failed to add market segment!");
        } finally {
            setLoading(false);
        }
    };


    const handleEditClick = (row) => {
        setSelectedRow(row);
    };

    // Handle input change inside Update modal
    const handleUpdateChange = (field, value) => {
        setSelectedRow((prev) => ({ ...prev, [field]: value }));
    };

    // Handle update submit
    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formdata = {
                ID: selectedRow.ID, // IMPORTANT: existing ID for update
                Code: selectedRow.Code,
                MarketSeg: selectedRow.MarketSeg,
            };

            await PropertySaveMarketsegment(formdata);

            swal("Market Segment Updated Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Update-market-Segment")
                );
                if (modal) modal.hide();
            });

            // Refresh list
            const result = await PropertyMarketSegmentApi();
            if (Array.isArray(result)) setMarketSegment(result);

        } catch (error) {
            console.log("Error updating market segment", error);
            alert("Failed to update market segment!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {(loading || deleting) && (
                <FullScreenLoader />
            )}

            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>{successMessage}</div>
                                        </div>
                                    )}



                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title">Market Segment List</h4>
                                                <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-market-Segment">Add </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">

                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Market Segment</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {marketSegment.length > 0 ? (
                                                            marketSegment.map((item) => (
                                                                <tr key={item.ID}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.MarketSeg}</td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2" data-bs-toggle="modal" data-bs-target="#Update-market-Segment" onClick={() => handleEditClick(item)}><i className="fas fa-edit"></i> </button>
                                                                        <button type="button" className="btn btn-danger btn-sm waves-effect waves-light py-1 px-2" onClick={() => handleDeleteClick(item.ID)} disabled={deleting}><i className="fas fa-trash"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* market segment modal content */}
                    <div
                        id="Add-market-Segment"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Market Segment</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "152px" }}>Code</th>
                                                <th>Market Segment</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Code"
                                                            value={row.code}
                                                            onChange={(e) =>
                                                                handleChange(index, "code", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text" className="form-control" placeholder="Enter Market Segment"
                                                            value={row.segment}
                                                            onChange={(e) => handleChange(index, "segment", e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        {index !== 0 && (
                                                            <button
                                                                className="btn btn-sm text-danger fs-6"
                                                                onClick={() => handleDeleteRow(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="text-end">
                                        <button className="btn btn-sm btn-primary" onClick={handleAddRow}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /.modal */}

                    {/* Update Market Segment Model */}
                    <div
                        id="Update-market-Segment"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Market Segment</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Code</label>
                                        <input type="text" className="form-control" value={selectedRow.Code || ""}
                                            onChange={(e) => handleUpdateChange("Code", e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Market Segment</label>
                                        <input type="text" className="form-control" value={selectedRow.MarketSeg || ""}
                                            onChange={(e) => handleUpdateChange("MarketSeg", e.target.value)} />
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleUpdate}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </>
    )
}
